import {
  Button,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { IoLogoGameControllerB } from "react-icons/io";
import { useNavigate } from "react-router";
import { COMMON_WEB_PATH } from "../../constant";
import { FaGhost } from "react-icons/fa";

const NotFound = ({ hiddenButton, customHint, icon }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`notFound.${key}`);

  const titleColor = useColorModeValue("dark.100", "light.100");

  const navigate = useNavigate();
  return (
    <Flex
      direction={`column`}
      alignItems={`center`}
      justifyContent={`center`}
      py={10}
      gap={4}
      width="100%"
    >
      <Icon as={FaGhost} color={`whiteAlpha.300`} fontSize="5em" />
      <Text
        fontWeight={`medium`}
        mb="10px"
        fontSize="16px"
        color={`whiteAlpha.300`}
        letterSpacing={`tight`}
      >
        {i18n("nothingFound")}
      </Text>
    </Flex>
  );
};

export default NotFound;
